import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'
import minus from '@vio/atlas/utils/minus'

export const Wrapper = styled.div`
  color: ${cssTheme.colors.content.neutral.secondary};
`

export const MobileWrapper = styled.div`
  color: ${cssTheme.colors.content.neutral.secondary};
  margin: 0 ${minus(cssTheme.layout.spacing.s100)} 0
    ${minus(cssTheme.layout.spacing.s100)} !important;
`

export const PlaceNameWrapper = styled(Text)`
  display: flex;
  gap: ${cssTheme.layout.spacing.s100};
  text-align: left;

  ${linariaMq.desktopXs} {
    align-items: center;
  }
`

export const MapLink = styled.span`
  text-decoration: underline;
`

export const LocationSummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${cssTheme.layout.spacing.s250};
  margin-bottom: ${cssTheme.layout.spacing.s250};
`

export const StreetViewText = styled(Text)`
  white-space: nowrap;
`
